export type LinkType = {
    label: string,
    url: string
};

export type SectionLinkType = {
    id: string,
    label: string,
    links: LinkType[],
};

const links: SectionLinkType[] = [
    {
        id: 'ABOUT_US',
        label: 'o nas',
        links: [
            {
                label: 'Historia GWO',
                url: 'https://gwo.pl/historia-gwo'
            },
            {
                label: 'Kodeks Dobrych Praktyk',
                url: 'https://gwo.pl/kodeks-dobrych-praktyk',
            },
            {
                label: 'Napisali o nas',
                url: 'https://gwo.pl/napisali-o-nas',
            },
            {
                label: 'Projekty UE',
                url: 'https://gwo.pl/projekty-ue',
            },
            {
                label: 'Regulaminy',
                url: 'https://gwo.pl/regulaminy',
            },
        ],
    },

    {
        id: 'DELIVERY',
        label: 'dostawa i płatność',
        links: [
            {
                label: 'Koszt dostawy',
                url: 'https://gwo.pl/koszt-dostawy',
            },
            {
                label: 'Formy płatności',
                url: 'https://gwo.pl/formy-platnosci',
            },
        ],
    },

    {
        id: 'CONTACT',
        label: 'kontakt',
        links: [
            {
                label: 'Skontaktuj się z nami',
                url: 'https://gwo.pl/skontaktuj-sie-z-nami',
            },
            {
                label: 'Przedstawiciele regionalni',
                url: 'https://gwo.pl/przedstawiciele-regionalni',
            },
        ],
    }
];

export default links;
